import { TailSpin } from 'react-loader-spinner'
import { createContext, useContext, useState } from 'react'

const LoadingContext = createContext({})

export function useLoading () {
  return useContext(LoadingContext)
}

export function LoadingProvider ({ children }) {
  const [loading, setLoading] = useState(false)

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      <Loading loading={loading}/>
      {children}
    </LoadingContext.Provider>
  )
}

function Loading ({ loading }) {
  if (loading) {
    return (<div style={{
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 2000,
      width: '100%',
      height: '100%',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
    }}>
      <TailSpin type="TailSpin" color="#00BFFF" height={80} width={80}/>
    </div>)
  }
}
